(function() {
    const checkboxes = document.querySelectorAll("#custom-options input[type='checkbox']");
    const submitButton = document.querySelector(".product-buy-buttons--primary");

    // 初期状態でsubmitボタンを無効化
    submitButton.disabled = true;

    checkboxes.forEach(checkbox => {
        checkbox.addEventListener("change", () => {
            const selectedCount = document.querySelectorAll("#custom-options input[type='checkbox']:checked").length;

            // チェックされたボックスが3つになったら、submitボタンを有効化
            if (selectedCount >= 3) {
                submitButton.disabled = false;

                // チェックボックスが3つ以上選択されている場合は、4つ目以降のチェックを防ぐ
                checkboxes.forEach(box => {
                    if (!box.checked) {
                        box.disabled = selectedCount >= 3;
                    }
                });
            } else {
                submitButton.disabled = true;

                // チェックボックスが3つ未満の場合は、全てのチェックボックスを有効化
                checkboxes.forEach(box => {
                    box.disabled = false;
                });
            }
        });
    });


})();